module.exports = __webpack_public_path__ + "static/media/americanExpress.89808ad8.png";